//import axios from 'axios';
import http from './httpService';  
//import {apiUrl} from './../config/config.json';
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl+'/cooitems';

  function userUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getCOOItems() {
    return http.get(apiEndpoint);
  }
  
  export function getCOOItem(userId) {
    return http.get(userUrl(userId));
  }
  
  export function saveCOOItem(user,imageSrc) {
    // const formData = new FormData(); 
   //update
   if (user._id) {
     //clone user and delete _id
     const body = { ...user };
     delete body._id;
     delete body.imageSrc;
    //  for ( let key in body ) {
    //     formData.append(key, body[key]);
    //     }
    //    formData.append('imageSrc', imageSrc);
     return http.put(userUrl(user._id), body);
   }
   const body = { ...user };
   delete body.imageSrc;
      // for ( let key in body ) {
      //   formData.append(key, body[key]);
      //   }
      //  formData.append('imageSrc', imageSrc);
   //add a new user
   return http.post(apiEndpoint, body);
 }

 // create batch update function
  export function batchUpdateCOOItems(data) {
    return http.post(apiUrl+'/cooitems/updatebatch', data);
  }
  
  export function batchAddCOOItems(data) {
    return http.post(apiUrl+'/cooitems/batch', data);
  }
  
  //delete users
  export function deleteCOOItem(userId) {
    return http.delete(userUrl(userId));
  }  